export interface IWatrReimbursement {
    id: number,
    reimbursementType: number,
    achNumber: string,
    confirmationCode: string,
    amount: number,
    date: string,
    createdDateTime?: string | Date | null,
    reimbursedUserId?: number | null,
    reimbursedDateTime?: string | Date | null,
    reimbursedUserName?: string | null,
    approverUserId?: number | null,
    approvedDateTime?: string | Date | null,
    approverName?: string | null,
    centerAlias?: string | null,
    donationOrganType: number,
    donorId: number,
    centerId: number,
    donorShieldId: number,
    firstName: string,
    lastName: string,
    donorAlias: string,
    fullName: string,
    address: string,
    city: string,
    state: string,
    zip: string,
    ssn: string,
    email: string,
    phone?: string | null,
    count: number,
    total: number,
    requestId: number,
    comments: string,
    dependentCareAmount: number,
    organDonated: string,
    weeksRequested: string,
    travelsRequested: string,
}